import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-16 pt-4 sm:pb-20 sm:pt-6" data-id="element-108" data-mp="9llb731mq8q5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-109" data-mp="4mi3fau9loeh">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="font-display text-[1.55rem] font-black uppercase leading-[1.05] tracking-tight text-brand sm:text-[3rem] md:text-[4rem]" style={{
        paddingTop: "15px"
      }} data-id="element-110" data-mp="4jm7fs1z99so">
          Solve an Entire Year of Tennis Coaching in Just{' '}
          <span className="text-lime-dark" data-id="element-111" data-mp="nbf0fmh1qv0e">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-ink/60 sm:mt-5 sm:text-lg" data-id="element-112" data-mp="3d1sa6w93nhsl">
          Join 2,500+ tennis coaches who stopped improvising. Walk onto every
          court with professional sessions already planned, organized, and ready
          to run.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto max-w-3xl pb-2 pt-2 sm:pb-4 sm:pt-4" data-id="element-113" data-mp="3e963buqzm9im">
          <img src="https://cdn.magicpatterns.com/uploads/cqw7ejRRiFYs6nyWMCnBsE/Diseno-sin-titulo-_61_.webp" alt="The Tennis Ready pack shown across six printed volumes, desktop, tablet and phone" className="w-full" data-id="element-114" data-mp="35aud3tu19dqp" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} data-id="element-115" data-mp="2hjoxnfs08ngx">
          <CtaButton href="#offer" data-id="element-116" data-mp="s2tffr2zujsd" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-117" data-mp="s3uqhvk0f6a3">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-118" data-mp="ici0zaloos78" data-mpi={index}>
                <span data-id="element-119" data-mp="de6n8os9pxjq">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-lime-dark/50" data-id="element-120" data-mp="1b15pdf1qbxp0">
                    •
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}